import { MilestoneStatus } from '@thoughtspot/blink-context';
import { Vertical } from '@thoughtspot/radiant-react/widgets/layout';
import { Typography } from '@thoughtspot/radiant-react/widgets/typography';
import cx from 'classnames';
import React from 'react';
import styles from './milestone-illustration.module.scss';
const MilestoneIllustration = ({ status, topLabel, middleLabel, bottomLabel, }) => {
    const isStarted = status === MilestoneStatus.STARTED;
    return (React.createElement(Vertical, { "data-testid": isStarted
            ? 'milestone-illustration-started'
            : 'milestone-illustration-finished', className: cx(styles.milestoneIllustrationContainer, {
            [styles.startedBgImage]: isStarted,
            [styles.finishedBgImage]: !isStarted,
        }) },
        React.createElement(Typography, { variant: isStarted ? 'p-small' : 'h4', className: cx(styles.topLabel, {
                [styles.greyColorText]: isStarted,
                [styles.multiColorText]: !isStarted,
            }) }, topLabel),
        React.createElement(Typography, { variant: isStarted ? 'p-small' : 'content-label-subhead', className: cx(styles.middleLabel, {
                [styles.greyColorText]: isStarted,
                [styles.multiColorText]: !isStarted,
            }) }, middleLabel),
        React.createElement(Typography, { variant: isStarted ? 'h4' : 'content-label-subhead', className: cx(styles.bottomLabel, styles.multiColorText) }, bottomLabel)));
};
export default MilestoneIllustration;
//# sourceMappingURL=milestone-illustration.js.map